/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-hospital-association.reducer';

export const PharmacyHospitalAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyHospitalAssociationEntity = useAppSelector(state => state.pharmacyHospitalAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyHospitalAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.detail.title">PharmacyHospitalAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.id}</dd>
          <dt>
            <span id="associatedDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.associatedDate">Associated Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.associatedDate}</dd>
          <dt>
            <span id="leavingDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.leavingDate">Leaving Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.leavingDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.cursor}</dd>
          <dt>
            <span id="openingTime">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.openingTime">Opening Time</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.openingTime}</dd>
          <dt>
            <span id="closeTime">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.closeTime">Close Time</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.closeTime}</dd>
          <dt>
            <span id="internal">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.internal">Internal</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.internal ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.modifiedBy}</dd>
          <dt>
            <span id="leftAssociation">
              <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.leftAssociation">Left Association</Translate>
            </span>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.leftAssociation ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.pharmacy ? pharmacyHospitalAssociationEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyHospitalAssociation.hospital">Hospital</Translate>
          </dt>
          <dd>{pharmacyHospitalAssociationEntity.hospital ? pharmacyHospitalAssociationEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-hospital-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-hospital-association/${pharmacyHospitalAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyHospitalAssociationDetail;
